export const WELCOME_BANNER_MESSAGES = {
    HIDE_CONFIRMATION_TITLE: 'Hide Welcome Message?',
    HIDE_CONFIRMATION_CONTENT:
        'This Welcome Message will no longer display upon login. OK to proceed?',
};
